export default __webpack_public_path__ + "44a526eed258222515aa21eaffd14a96.png";